import { FC } from "react";
import UnifiedLegislationHTMLView from "./UnifiedLegislationHTMLView";

/**
 * App-route entry for legislation HTML documents.
 * Renders the unified viewer immediately so chrome (timeline, breadcrumbs) persists
 * while the active document loads — no full-page LoadingView gate.
 */
const LegislationViewRouter: FC = () => <UnifiedLegislationHTMLView />;

export default LegislationViewRouter;
